import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UploadFileService } from '../upload-file.service';
import { FileUpload } from '../fileupload';
import { FormGroup, Validators, FormControl } from '@angular/forms';

import { finalize } from 'rxjs/operators';
import { AngularFireStorage } from '@angular/fire/compat/storage';


@Component({
  selector: 'app-follow-up-form-upload',
  templateUrl: './follow-up-form-upload.component.html',
  styleUrls: ['./follow-up-form-upload.component.scss'],
  inputs: ['idBot','uploadfilePath','imagelink','ShowAlt','infoImage','idCatalog','for_product_preview','idUser', 'imageRatio']
})

export class FollowUpFormUploadComponent {
  for_product_preview
  selectedFiles!: FileList | undefined;
  currentFileUpload!: FileUpload;
  progress: { percentage: number } = { percentage: 0 };
  botImageURL!: boolean;
  download!: boolean;
  downloadURL: any;
  uploadfilePath;
  infoImage;
  link: any;
  image;
  imagelink: any;
  idBot;
  ShowAlt;
  showURL=false
  showALTValue=false
  idUser : any
  imageRatio! : boolean
  @Output() urlImageCard = new EventEmitter();
  @Output() showURLInput = new EventEmitter();
  @Output() showALTInput = new EventEmitter();
  @Output() imageRatioType = new EventEmitter();
  cities: any[] | undefined;
  selectedCity : any;
  constructor(private uploadService: UploadFileService,
    private storage: AngularFireStorage,
    ) { }
   
  ngOnInit() {

    this.cities = [
      { name: 'New York', code: 'NY' },
      { name: 'Rome', code: 'RM' },
      { name: 'London', code: 'LDN' },
      { name: 'Istanbul', code: 'IST' },
      { name: 'Paris', code: 'PRS' }
  ];
  }
  
  URLInput(){
    this.showURL=!this.showURL
    this.showURLInput.emit(this.showURL);
  }
  ALTInput(){
    this.showALTValue=!this.showALTValue
    this.showALTInput.emit(this.showALTValue);
  }
 
 
  selectFile(event) {
    this.selectedFiles = event.target.files;
    setTimeout(() => {  this.upload()}, 1000);   

  }
 
  upload() {
    const file = this.selectedFiles?.item(0) ;
    this.selectedFiles = undefined;
   if ( file != undefined )
     this.currentFileUpload = new FileUpload(file);
    


    this.botImageURL=false;
    this.download =true;
    const filePath =  this.uploadfilePath;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, file);
    task.snapshotChanges().pipe(
        finalize(() => this.downloadURL = fileRef.getDownloadURL() )
     )
    .subscribe(image=>{
    
      this.link = fileRef.getDownloadURL().subscribe(tt=>{
        this.imagelink =tt;
        if (this.imagelink)
        this.urlImageCard.emit(this.imagelink);
      });
    })
  }
  changeImageRatio(event)
{
  this.imageRatioType.emit(event.value);
}
}
